import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  setPucksData(state, action: PayloadAction<any>) {
    state.isLoading = true;
  },
  setPucksSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  setPucksFailure(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
